var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMessageCircle = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#212831",
  fillRule: "evenodd",
  d: "M13.018 2c4.89.2 8.683 4.1 8.982 8.9v.5c0 1.5-.3 3-.998 4.3-1.597 3.2-4.89 5.2-8.483 5.2-1.398 0-2.695-.3-3.893-.8l-5.29 1.8c-.1.1-.199.1-.299.1-.3 0-.499-.1-.798-.3-.2-.2-.3-.6-.2-1l1.797-5.3c-.5-1.2-.799-2.6-.799-3.9 0-3.6 1.996-6.9 5.29-8.5 1.297-.7 2.694-1 4.192-1zm6.188 12.9c.498-1.1.798-2.2.798-3.4V11c-.3-3.8-3.294-6.8-7.086-7h-.4c-1.097 0-2.295.3-3.293.8-2.595 1.3-4.192 3.8-4.192 6.7 0 1.1.3 2.3.799 3.3.2.3.2.5.1.8l-1.298 3.8 3.793-1.3c.3 0 .598 0 .798.1.998.5 2.196.8 3.294.8 2.894 0 5.389-1.5 6.687-4.1",
  clipRule: "evenodd"
})));
export default SvgMessageCircle;